var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenoteLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "#FFF4DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_225)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3005 11.9633V5.10342C12.3005 5.04701 12.2535 5 12.1971 5H11.1034C11.047 5 11 5.04701 11 5.10342V20.0799C11 20.1489 11.0689 20.199 11.1348 20.1802L18.2955 17.9395C18.3613 17.9176 18.4303 17.9677 18.4303 18.0398V24.8997C18.4303 24.9561 18.4773 25.0031 18.5337 25.0031H19.6243C19.6807 25.0031 19.7277 24.9561 19.7277 24.8997V9.92009C19.7277 9.85114 19.6587 9.801 19.5929 9.81981L12.4322 12.0605C12.3663 12.0824 12.2974 12.0323 12.2974 11.9602L12.3005 11.9633ZM12.3005 18.3124V13.5396C12.3005 13.4958 12.3287 13.455 12.3726 13.4394L18.2955 11.5841C18.3613 11.5622 18.4303 11.6123 18.4303 11.6844V16.4572C18.4303 16.5011 18.4021 16.5418 18.3582 16.5575L12.4353 18.4127C12.3695 18.4347 12.3005 18.3845 12.3005 18.3124Z",
    fill: "#CC962B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.72767,
    height: 20,
    fill: "white",
    transform: "translate(11 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenoteLock);
export default __webpack_public_path__ + "static/media/renote_lock.a70d13976aafa787c143637fa40ee63f.svg";
export { ForwardRef as ReactComponent };